import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/styles';
import { Switch, Route, useLocation, useRouteMatch } from 'react-router-dom';

import ViewTitle from '../../common/view-title';
import Loader from '../../common/loader';
import NotFound from '../../common/not-found';

import TicketSedeTransferMenu from './ticket-sede-transfer-menu';
import TicketSedeTransferCreate from './ticket-sede-transfer-create';
import TicketSedeTransferDetail from './ticket-sede-transfer-detail';
import TicketSedeTransferEdit from './ticket-sede-transfer-edit';
import TicketSedeTransferIndex from './ticket-sede-transfer-index';
import TicketSedeTransferReport from './ticket-sede-transfer-report';

import helpers from '../../utils/helpers';

const useStyles = makeStyles(() => ({
    root: {
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
    }
}));

const TicketSedeTransfer = () => {

    const classes = useStyles();
    const { pathname } = useLocation();
    const { path } = useRouteMatch();
    const [state, setState] = useState({
        loading: true,
        permissions: {}
    });

    useEffect(() => {
        const validatePermissions = () => {
            const permissions = helpers.getPermissions(pathname);
            setState(prev => ({ ...prev, permissions, loading: false }));
        }

        validatePermissions();
    }, []);

    if (state.loading) {
        return <Loader />;
    }

    if (!state.permissions?.read_attr) {
        return <NotFound />;
    }

    return (
        <div className={classes.root}>
            <ViewTitle sedeFlag title='Ticket sede transfer' />

            <Switch>
                <Route exact path={path}><TicketSedeTransferMenu permissions={state.permissions} /></Route>
                <Route exact path={`${path}/report`}><TicketSedeTransferReport permissions={state.permissions} /></Route>
                <Route exact path={`${path}/create`}><TicketSedeTransferCreate permissions={state.permissions} /></Route>
                <Route exact path={`${path}/index`}><TicketSedeTransferIndex permissions={state.permissions} /></Route>
                <Route exact path={`${path}/:id/edit`}><TicketSedeTransferEdit permissions={state.permissions} /></Route>
                <Route exact path={`${path}/:id`}><TicketSedeTransferDetail permissions={state.permissions} /></Route>
                <Route path={`${path}/*`}><NotFound /></Route>
            </Switch>
        </div>
    );
}

export default TicketSedeTransfer;